<div class="progress loop"><progress></progress></div>